import { useEffect, useRef } from 'react';
import Overlay from '../../ui/Overlay';
import Button from '../../ui/Button';
import { deleteProject } from '../../apis/projects/projects';
import { toast } from 'sonner';
import Feedbackclose from '../../assets/icons/Feedbackclose';
import { deleteBounty, updateBountyExpiration } from '../../apis/bounties/bounties';
import ModalBox from '../../ui/ModalBox';
import { useLoadingState } from '../../hooks/useLoader';

function ForcefullyExpireBountyModal({ close, bountyName, bountyId, onForcefullyExpire }) {
    const myRef = useRef({ close });
    const { loading, startLoading, stopLoading } = useLoadingState();
    useEffect(
        function () {
            function handleClick(e) {
                if (myRef.current && !myRef.current.contains(e.target)) {
                    close();
                }
            }

            document.addEventListener('click', handleClick, true);

            return () => document.removeEventListener('click', handleClick, true);
        },
        [close]
    );
    return (
        <Overlay>
            <div
                ref={myRef}
                className="absolute rounded-lg left-[50%]     bg-grayBgNormal translate-x-[-50%] translate-y-[-50%] top-[50%]"
            >
                <ModalBox
                    close={close}
                      width="w-[32.75rem]"
                    supportText={"Forcefully expiring the bounty will take it off Impact Miner such that you can move onto validating the submissions."}
                    onSubmit={async () => {
                        try {
                            startLoading();
                            const {newBountyStatus} = await updateBountyExpiration(bountyId,"EXPIRE");
                            console.log({newBountyStatus},'response after expiry');
                            if (newBountyStatus) {
                                onForcefullyExpire('expire', newBountyStatus);
                                toast.success('Bounty successfully expired. ');
                            }
                        } catch (error) {
                            console.log(error);
                        } finally {
                            close(); // Close modal after duplication
                            stopLoading();
                        }
                    }}
                    primaryBtnText={'Yes'}
                    loading={loading}
                    secondaryBtnText={'Cancel'}
                >
                    <>
                        Are you sure you want to <span className="font-bold">forecefully expire the bounty the  '{bountyName}' </span>?
                    </>
                    
                </ModalBox>
            </div>
        </Overlay>
    );
}

export default ForcefullyExpireBountyModal;
